import { postApiRequest } from "@msidentity/sisu/utilities/request/request-helper";
import { setCommonAccountPostRequestData } from "../api-request-helper";
import {
  type GetAccountsForProofRequest,
  type GetAccountsForProofResponse,
} from "./get-accounts-for-proof-types";

/**
 * This a wrapper method that makes a POST request to the GetAccountsForProof API.
 * @param requestUrl the URL to the GetAccountsForProof API.
 * @param requestParams The GetAccountsForProof request parameters.
 * @returns A promise of the API response.
 */
export const getAccountsForProof = (
  requestUrl: string,
  requestParams: GetAccountsForProofRequest,
): Promise<GetAccountsForProofResponse> => {
  const requestBody = {
    ...setCommonAccountPostRequestData(),
    ...requestParams,
  };

  const options = { body: JSON.stringify(requestBody) };
  return postApiRequest<GetAccountsForProofResponse>(requestUrl, options);
};
